import * as React from 'react';
import MainBrand from 'img/brand.svg';
import { Spinner } from 'reactstrap';
export default function () {
    return React.createElement("div", { className: "m-auto" },
        React.createElement(MainBrand, { className: "w-25" }),
        React.createElement(Spinner, null));
}
